import intersect from '@turf/intersect';
import area from '@turf/area';
import { uniq } from 'lodash';
import liverpoolDensity from './liverpoolDensity.json';

export const calculateDensities = newSelection => {
  // TODO only check density features near lot(s) 
  const densities = uniq(
    liverpoolDensity.features.map(f => f.properties.MIN_RDN)
  );
  const densityAreas = densities.reduce((prev, cur) => {
    return {
      ...prev,
      [cur]: liverpoolDensity.features
        .filter(f => f.properties.MIN_RDN === cur)
        .reduce((totalArea, densityF) => {
          return (
            10 * // round to nearest 10 sqm
            Math.round(
              (totalArea +
                newSelection.reduce((densityFArea, lot) => {
                  const intersection = intersect(lot, densityF);
                  if (intersection) return densityFArea + area(intersection);
                  return densityFArea;
                }, 0)) /
                10
            )
          );
        }, 0)
    };
  }, {});
  return densityAreas;
};
